/* eslint-disable consistent-return */
import { useScreenSize } from '@hooks';
import { activityApi } from '@store';
import { Button, Flex, Image, theme, Typography } from '@styles';
import { ReactComponent as EyeIcon } from '@svgs/eye.svg';
import { ReactComponent as VideoPlayerIcon } from '@svgs/video-player.svg';
import { number, string } from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '../Icon';
import { Modal } from '../Modal';
import { VideoPlayer } from '../VideoPlayer';
import { getImageHeight } from './VideoCard.styles';

const VideoCard = ({
  id,
  subtitleText,
  titleText,
  videoImage,
  videoUrl,
  wasSeenCount,
}) => {
  const { i18n } = useTranslation();
  const { dynamicHeight, dynamicWidth, isLaptop, isTabletSM } = useScreenSize();

  const [isVideoPlayerVisisble, setVideoplayerVisisble] = useState(false);

  const [logVideoView] = activityApi.useLogVideoViewMutation();

  const handleNavigateButtonClick = async () => {
    setVideoplayerVisisble(true);
    await logVideoView({ id });
  };

  return (
    <>
      <Modal
        isVisible={isVideoPlayerVisisble}
        modalContainerProps={{
          backgroundColor: 'transparent',
          borderRadius: '0px',
          height: '100%',
          maxHeight: '675px',
          mt: '24px',
          padding: '16px',
        }}
        modalMaxHeight="100%"
        modalMaxWidth={1000}
        setModalVisible={setVideoplayerVisisble}
        withBackdropNoise
      >
        {isVideoPlayerVisisble && (
          <VideoPlayer
            dynamicHeight={dynamicHeight}
            dynamicWidth={dynamicWidth}
            videosrc={videoUrl}
          />
        )}
      </Modal>
      <Button
        alignItems="flex-start"
        borderProps={`1px solid ${theme.colors.whiteLine[100]}`}
        borderRadius={0}
        height={isLaptop ? 376 : 470}
        justifyContnet="flex-start"
        onClick={handleNavigateButtonClick}
        p={0}
        variant="textButton"
        width={isTabletSM ? '100%' : 'calc(50% - 2px)'}
      >
        <Flex
          alignItems="flex-start"
          flexDirection="column"
          position="relative"
          width="100%"
        >
          <Image
            alt="Video image"
            backgroundSize="cover"
            height={getImageHeight({ dynamicWidth })}
            mb={isLaptop ? 32 : 36}
            src={videoImage}
            style={{
              objectFit: 'cover',
            }}
            width="100%"
          />
          <Flex left={16} position="absolute" top={isLaptop ? 142 : 200}>
            <Icon height={80} SVG={VideoPlayerIcon} width={80} />
          </Flex>
          <Flex alignItems="flex-start" flexDirection="column" px={3}>
            <Typography
              color={theme.colors.white[60]}
              mb={2}
              variant={isLaptop ? 'MS-regular-s20-lh31' : 'MS-regular-s26-lh40'}
            >
              {`${i18n.t('ProfilePage.Module')} ${subtitleText}`}
            </Typography>
            <Typography
              color={theme.colors.white[100]}
              mb={2}
              textAlign="left"
              variant={isLaptop ? 'BN-bold-s24-lh21' : 'BN-bold-s36-lh75'}
            >
              {titleText}
            </Typography>
            <Flex>
              <Icon color={theme.colors.alto[100]} mr={2} SVG={EyeIcon} />
              <Typography
                color={theme.colors.white[100]}
                variant="MS-regular-s14-lh22"
              >
                {wasSeenCount}
              </Typography>
            </Flex>
          </Flex>
        </Flex>
      </Button>
    </>
  );
};

VideoCard.propTypes = {
  id: number.isRequired,
  subtitleText: string.isRequired,
  titleText: string.isRequired,
  videoImage: string.isRequired,
  videoUrl: string.isRequired,
  wasSeenCount: number.isRequired,
};

export default VideoCard;
